<template>
<v-card class="mx-auto" tile>
    <v-text-field single-line filled v-model="search" label="Buscar" prepend-inner-icon="search"></v-text-field>
    <v-list rounded>
        <!-- <v-subheader>Relatórios</v-subheader> -->
        <v-list-item-group v-model="selectedItem" color="primary">
            <v-list-item v-for="(item, i) in filteredList" :key="i" @click="openLink(item.link)">
                <v-list-item-icon>
                    <v-icon>link</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list-item-group>
    </v-list>
</v-card>
</template>

<script>
export default {
  data () {
    return {
      links: [],
      search: '',
      items: [{
        text: 'Paulo Afonso - Centro',
        link: 'https://evertonpastor.typeform.com/report/MYotuVty/fforsxMVcfTrPWzO'
      },
      {
        text: 'Paulo Afonso - BTN',
        link: 'https://evertonpastor.typeform.com/report/NEwTLZzv/sJ0TQzOB6961Glnq'
      },
      {
        text: 'Anguera',
        link: 'https://evertonpastor.typeform.com/report/fTuWOp2v/psJhGxY7K3VboMLQ'
      },
      {
        text: 'Agua Fria',
        link: 'https://evertonpastor.typeform.com/report/hAoCL0rN/sWSSV5u6PtrbmkpL'
      },
      {
        text: 'Alagoinhas',
        link: 'https://evertonpastor.typeform.com/report/zhzxE4Mq/R4sExE4uGcNQSot6'
      },
      {
        text: 'Conceição da Feira',
        link: 'https://evertonpastor.typeform.com/report/VwIzguVW/u2yb9VQXqUhWWcWg'
      },
      {
        text: 'Conceição do Jacuípe',
        link: 'https://evertonpastor.typeform.com/report/YxVK3ETy/T2jrymHsqUhWIOFl'
      },
      {
        text: 'Coração de Maria',
        link: 'https://evertonpastor.typeform.com/report/AqhS4cXS/8fczVXQEkdIWE9N1'
      },
      {
        text: 'Coração de Maria II',
        link: 'https://evertonpastor.typeform.com/report/pfJpdyWc/njeB2ZWMcV7mDnNO'
      },
      {
        text: 'Euclides da Cunha',
        link: 'https://evertonpastor.typeform.com/report/yIdWJTgo/sfYeVSvGTyOhfwPJ'
      },
      {
        text: 'Humildes',
        link: 'https://evertonpastor.typeform.com/report/Glxt7I8P/5RyDho7cAzO0g5tC'
      },
      {
        text: 'Ipecaéta',
        link: 'https://evertonpastor.typeform.com/report/FW4Px0fy/U2o4Lmz67YT7fz42'
      },
      {
        text: 'Irará - Centro',
        link: 'https://evertonpastor.typeform.com/report/H2EAuyij/JqphkBy3a95wyfON'
      },
      {
        text: 'Irará - Clinica',
        link: 'https://evertonpastor.typeform.com/report/f3NSbYr3/Sdvxswy63iCzKDKf'
      },
      {
        text: 'Itatim',
        link: 'https://evertonpastor.typeform.com/report/twOhMwIA/uNCYodlEHQBFjohU'
      },
      {
        text: 'Maragogipe',
        link: 'https://evertonpastor.typeform.com/report/suGBJ4d8/TpRqHxVBXLEAn61j'
      },
      {
        text: 'Milagres',
        link: 'https://evertonpastor.typeform.com/report/SaTkROmV/u6Qqn7BISyUJ2BrE'
      },
      {
        text: 'Rafael Jambeiro',
        link: 'https://evertonpastor.typeform.com/report/XIV3eHYc/l4MqLSQvBH6O2mFv'
      },
      {
        text: 'Riachão do Jacuipe',
        link: 'https://evertonpastor.typeform.com/report/hvfjlHzM/heqIeVv1DzTKoAAJ'
      },
      {
        text: 'Ribeira do Pombal',
        link: 'https://evertonpastor.typeform.com/report/F5oa739D/PBAow5UWgr18NwdR'
      },
      {
        text: 'Santo Estevão II',
        link: 'https://evertonpastor.typeform.com/report/mgA67nWI/IoJP7DDjJisL7khT'
      },
      {
        text: 'São Felix',
        link: 'https://evertonpastor.typeform.com/report/GtmJL3Lj/TZAb20Ff8hthiKfG'
      },
      {
        text: 'Sapeçú',
        link: 'https://evertonpastor.typeform.com/report/JfNCguVg/ptK7BaDZz1fu80W2'
      },
      {
        text: 'Tanquinho',
        link: 'https://evertonpastor.typeform.com/report/oGwKNUwZ/Q2dpGJavEh4gJwPl'
      },
      {
        text: 'Terra Nova',
        link: 'https://evertonpastor.typeform.com/report/uGxQ04g3/MDFKp0MsMDcZ0rUv'
      },
      {
        text: 'Cidade Nova',
        link: 'https://evertonpastor.typeform.com/report/mULMjz4R/bxbDeyzdAOM6x0wQ'
      },
      {
        text: 'Conceoção I',
        link: 'https://evertonpastor.typeform.com/report/KneCuFLJ/UHda7rSzAWNB6Voo'
      },
      {
        text: 'Feira IX',
        link: 'https://evertonpastor.typeform.com/report/XoqBRSIQ/kqINdtBm5cASN3VE'
      },
      {
        text: 'Feira VII',
        link: 'https://evertonpastor.typeform.com/report/XoVLRNSJ/wa9HAepRlFgKgQ7S'
      },
      {
        text: 'Feira X',
        link: 'https://evertonpastor.typeform.com/report/tT1EfirQ/Gdd7X706VOOn1uUF'
      },
      {
        text: 'Fraga Maia',
        link: 'https://evertonpastor.typeform.com/report/NxJQ6pz0/dVLvH2hsT3bQ9ZQ0'
      },
      {
        text: 'Pampalona',
        link: 'https://evertonpastor.typeform.com/report/TFhUs5Kr/IQm6uRHjHHXCzhKZ'
      },
      {
        text: 'Sobradinho',
        link: 'https://evertonpastor.typeform.com/report/crpbBXUO/CH4vbjaGaZkBMzxY'
      },
      {
        text: 'Calumbi',
        link: 'https://evertonpastor.typeform.com/report/AML4RYLj/ZWL1BWvgKZAmAp3v'
      },
      {
        text: 'Sede',
        link: 'https://evertonpastor.typeform.com/report/IBx4hNWZ/vxdFVE77KfnAInUR'
      },
      {
        text: 'Amelia Rodrigues',
        link: 'https://evertonpastor.typeform.com/report/u6ZMGnD6/jGLArNLOUZLfjrSb'
      },
      {
        text: 'Amelia  - Itapicuru',
        link: 'https://evertonpastor.typeform.com/report/v7bDc36k/atz7Vtffmltaq7bT'
      },
      {
        text: 'Cruz das Almas',
        link: 'https://evertonpastor.typeform.com/report/wGPH4icY/ZxvvlVQkUEMKs11w'
      },
      {
        text: 'Pé de serra',
        link: 'https://evertonpastor.typeform.com/report/zz6IsYSm/1sTRIgxxvxfCMPTt'
      },
      {
        text: 'Santo Estevão I',
        link: 'https://evertonpastor.typeform.com/report/somwzmsS/3DotvSKm6xmL8m4Z'
      },
      {
        text: 'São Gonçalo',
        link: 'https://evertonpastor.typeform.com/report/vL6clHHX/a5JqG8zToKMWBU62'
      },
      {
        text: 'São José',
        link: 'https://evertonpastor.typeform.com/report/Ue0haM8k/Uxg0TL556AikENyD'
      },
      {
        text: 'Tucano',
        link: 'https://evertonpastor.typeform.com/report/fjtIz8qh/vc1thaVhXz1UjXVR'
      },
      {
        text: 'George Americo',
        link: 'https://evertonpastor.typeform.com/report/qfIyPY4s/Mb9v8pxeUKzTR33p'
      }
      ]
    }
  },
  methods: {
    openLink: function (link) {
      window.open(link, '_blank')
    }
  },
  computed: {
    filteredList () {
      return this.items.filter(post => {
        return post.text.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  }
}
</script>
